const mutations = {
  setSession: (state, data) => (state.session_check = data),
  setGatorDevices: (state, data) => (state.gator_devices = data),
  setHistoryList: (state, data) => (state.history_list = data),
  setImgList: (state, data) => (state.img_list = data)
}

export default mutations
